
define(
	'nowakdental.ADAComplaince.ADAComplaince'
,   [
		'nowakdental.ADAComplaince.ADAComplaince.View'
	]
,   function (
		ADAComplainceView
	)
{
	'use strict';

	var ADA_TITLE = 'Nowak Dental Supplies';
	var ADA_ALT = 'Loading';

	function setTitleAndAlt() {
		try {
			if (document.title !== ADA_TITLE) {
				document.title = ADA_TITLE;
			}
			var loader = document.getElementById('loadingIndicator');
			if (loader && !loader.getAttribute('alt')) {
				loader.setAttribute('alt', ADA_ALT);
			}
			return !!(loader && loader.getAttribute('alt'));
		} catch (e) {
			return false;
		}
	}

	// SEO fix: all of the timers/observers below must NOT run during SEO
	// prerender (Prerender V2 / page generator):
	//  - the 10-second observer-disconnect setTimeout and the 100ms retry
	//    setInterval keep the page "busy" for ~10s, so the generator times
	//    out and marks every page "PossiblyIncomplete" (cached blank).
	//  - overwriting document.title would also replace every product page
	//    title with the generic site name in the prerendered HTML.
	// Real shoppers are unaffected; everything below still runs for them.
	var isSEOPrerender = typeof SC !== 'undefined' &&
		typeof SC.isPageGenerator === 'function' && SC.isPageGenerator();

	if (!isSEOPrerender) {

	// 1) Run immediately at module-define time (as early as possible).
	setTitleAndAlt();

	// 2) Run again on DOMContentLoaded.
	if (document.addEventListener) {
		document.addEventListener('DOMContentLoaded', setTitleAndAlt);
		window.addEventListener('load', setTitleAndAlt);
	}

	// 3) Use MutationObserver to catch the loader the moment it appears.
	if (typeof MutationObserver !== 'undefined') {
		var observer = new MutationObserver(function () {
			if (setTitleAndAlt()) {
				observer.disconnect();
			}
		});
		if (document.documentElement) {
			observer.observe(document.documentElement, { childList: true, subtree: true });
		}
		// Safety: stop observer after 10 seconds.
		setTimeout(function () { observer.disconnect(); }, 10000);
	}

	// 4) Final retry loop as a belt-and-braces safety net.
	var attempts = 0;
	var interval = setInterval(function () {
		attempts++;
		if (setTitleAndAlt() || attempts >= 60) {
			clearInterval(interval);
		}
	}, 100);

	} // end if (!isSEOPrerender) — SEO fix

	return  {
		mountToApp: function mountToApp (container)
		{
			// SEO fix: don't overwrite the page title during SEO prerender.
			if (!isSEOPrerender) {
			setTitleAndAlt();
			}

			var layout = container.getComponent('Layout');

			if(layout)
			{
				layout.addChildView('Header.Logo', function() {
					return new ADAComplainceView({ container: container });
				});
			}
		}
	};
});
